// extracted by mini-css-extract-plugin
export default {"loader_container":"styles_loader_container__+8SFH"};